tailwind.config = {
  theme: {
    extend: {
      colors: {
        primary: '#3730A3',
        secondary: '#64748B'
      }
    }
  }
}


const btn = document.querySelector("button.mobile-menu-button");
const menu = document.querySelector(".mobile-menu");

btn.addEventListener("click", () => {
  menu.classList.toggle("hidden");
});

// tab part 

const links = document.querySelectorAll('.tab-link');

links.forEach(link => {
  link.addEventListener('click', function () {
    links.forEach(l => l.className = 'tab-link py-4 uppercase text-[18px] font-medium text-[#0000003b] mx-10');
    this.className += ` ${this.getAttribute('data-active')}`;
  });
});

//  smooth scroll 
function smoothScroll(event, targetId) {
  event.preventDefault();

  const targetElement = document.querySelector(targetId);
  if (!targetElement) return;

  const startPosition = window.pageYOffset;
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 1000;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    window.scrollTo(0, startPosition + distance * progress);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}

// carousel slider 

document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector('.owl-carousel');

  if (carousel) {
    $(carousel).owlCarousel({
      items: 2,
      loop: true,
      margin: 10,
      nav: false,
      dots: false,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1
        },
        520: {
          items: 2
        },
        770: {
          items: 2
        },
        1280: {
          items: 2
        }
      }
    });
  }
});

// desktop searchbar

document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.search-icon');
  const searchBar = document.querySelector('.search-bar');
  const navLinks = document.getElementById('nav-links');
  const searchInput = searchBar.querySelector('input');

  const toggleSearchBar = (e) => {
    e.stopPropagation();
    searchBar.classList.toggle('hidden');
    navLinks.classList.toggle('hidden');

    if (!searchBar.classList.contains('hidden')) {
      searchInput.focus();
    }
  };


  const hideSearchBarOnClickOutside = (e) => {
    if (!searchBar.contains(e.target) && !searchIcon.contains(e.target)) {
      searchBar.classList.add('hidden');
      navLinks.classList.remove('hidden');
    }
  };

  searchIcon.addEventListener('click', toggleSearchBar);
  document.addEventListener('click', hideSearchBarOnClickOutside);
});

// mobile searchbar
document.addEventListener('DOMContentLoaded', function () {
  const searchIcon = document.querySelector('.search-icon-mobile');
  const searchBar = document.querySelector('.search-bar-mobile');
  const searchInput = searchBar.querySelector('input');

  const toggleSearchBar = (e) => {
    e.stopPropagation();
    searchBar.classList.toggle('hidden');

    if (!searchBar.classList.contains('hidden')) {
      searchInput.focus();
    }
  };

  

  const hideSearchBarOnClickOutside = (e) => {
    if (!searchBar.contains(e.target) && !searchIcon.contains(e.target)) {
      searchBar.classList.add('hidden');
    }
  };

  searchIcon.addEventListener('click', toggleSearchBar);
  document.addEventListener('click', hideSearchBarOnClickOutside);
});

// dropdown


document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggles = document.querySelectorAll('.dropdownToggle');

  dropdownToggles.forEach(toggle => {
    const dropdownContainer = toggle.closest('.dropdown-container');
    const dropdown = dropdownContainer.querySelector('.dropdown'); 

    if (dropdown) {
      const dropdownImage = document.createElement('img');
      dropdownImage.src = "https://cdn.shopify.com/s/files/1/0024/0490/9115/files/down-arrow.png?v=1728901415";
      dropdownImage.classList.add('dropdownImage', 'transition-transform', 'duration-300', 'ease-in-out');
      dropdownImage.style = "width:12px;height:12px"; // Set image size
      dropdownImage.alt = 'dropdown';
      toggle.appendChild(dropdownImage);

      let hideTimeout;

      toggle.addEventListener('mouseenter', function () {
        clearTimeout(hideTimeout); 
        dropdown.classList.remove('hidden'); 
        dropdownImage.style.transform = 'rotate(180deg)'; 
      });

      // Hide dropdown on mouse leave
      dropdownContainer.addEventListener('mouseleave', function () {
        hideTimeout = setTimeout(() => {
          dropdown.classList.add('hidden'); 
          dropdownImage.style.transform = 'rotate(0deg)'; 
        }, 300);
      });

    
      dropdownContainer.addEventListener('mouseenter', function () {
        clearTimeout(hideTimeout); 
      });

      
      document.addEventListener('click', function (event) {
        if (!dropdownContainer.contains(event.target)) {
          dropdown.classList.add('hidden'); 
          dropdownImage.style.transform = 'rotate(0deg)'; 
          clearTimeout(hideTimeout); 
        }
      });
    }
  });

  // Function to hide all dropdowns (if needed)
  function hideAllDropdowns() {
    dropdownToggles.forEach(toggle => {
      const dropdown = toggle.closest('.dropdown-container').querySelector('.dropdown');
      const dropdownImage = toggle.querySelector('.dropdownImage');
      if (dropdown) {
        dropdown.classList.add('hidden'); // Hide dropdown
        dropdownImage.style.transform = 'rotate(0deg)'; 
      }
    });
  }
});


///////

// mobile dropdown


document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggles = document.querySelectorAll('.dropdownButtonMobile');


  function appendDropdownImage(toggle) {
    const dropdownImage = document.createElement('img');
    dropdownImage.src = "https://cdn.shopify.com/s/files/1/0024/0490/9115/files/down-arrow.png?v=1728901415";
    dropdownImage.style = "width:10px;height:10px"; 
    dropdownImage.classList.add('dropdownImage', 'transition-transform', 'duration-300', 'ease-in-out');
    dropdownImage.alt = 'dropdown';
    toggle.appendChild(dropdownImage); 
  }

  dropdownToggles.forEach(toggle => {

  const dropdownContainer1 = toggle.closest('.dropdown-container1');

    const dropdownMobile = toggle.nextElementSibling; 
    if(dropdownContainer1 && dropdownMobile){
      appendDropdownImage(toggle);
    }
    
    
    toggle.addEventListener('click', function (event) {
      event.stopPropagation();
      const isHidden = dropdownMobile.classList.toggle('hidden'); 
      const dropdownImage = toggle.querySelector('.dropdownImage');
      dropdownImage.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)'; 
    });
  });

  // Click outside the dropdown closes it
  document.addEventListener('click', function (event) {
    dropdownToggles.forEach(toggle => {
      const dropdownMobile = toggle.nextElementSibling; 

      
      if (!toggle.contains(event.target) && !dropdownMobile.contains(event.target)) {
        dropdownMobile.classList.add('hidden'); 
        const dropdownImage = toggle.querySelector('.dropdownImage');
        dropdownImage.style.transform = 'rotate(0deg)'; 
      }
    });
  });
});



// collection-slider

$(document).ready(function(){

    var owl = $(".category-carousel");

    owl.owlCarousel({
        loop: true,
        margin: 20,
        dots: false,
        nav: false,
        autoplay: true,
        smartSpeed: 600,
        responsive: {
            0: { items: 1 },
            300: { items: 2 },
            640: { items: 3 },
            1025: { items: 4 }
        }
    });

    // Custom Arrows
    $(".owl-prev-custom").click(function() {
        owl.trigger("prev.owl.carousel");
    });

    $(".owl-next-custom").click(function() {
        owl.trigger("next.owl.carousel");
    });

});

  function toggleFAQ(btn) {
    const content = btn.nextElementSibling;
    const icon = btn.querySelector('.faq-icon');

    // Close all other FAQs
    document.querySelectorAll('.faq-content').forEach((item) => {
      if (item !== content) {
        item.style.maxHeight = null;
      }
    });

    document.querySelectorAll('.faq-icon').forEach((ic) => {
      if (ic !== icon) {
        ic.style.transform = 'rotate(0deg)';
      }
    });

    // Toggle current FAQ
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      icon.style.transform = 'rotate(0deg)';
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.style.transform = 'rotate(45deg)';
    }
  }

// Auto-open first FAQ on load (only if FAQ exists on the page)
window.addEventListener("DOMContentLoaded", () => {
  const firstBtn = document.querySelector(".faq-btn");
  if (!firstBtn) return; // stop here if no FAQ found

  const firstContent = firstBtn.nextElementSibling;
  const firstIcon = firstBtn.querySelector(".faq-icon");

  if (firstContent) {
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";
  }
  if (firstIcon) {
    firstIcon.style.transform = "rotate(45deg)";
  }
});
